export const clinicInfo = {
  name: 'OdontoDentine',
  phone: '+55 81 9645-9790',
  phoneDisplay: '(81) 96459-9790',
  email: 'contato@odontodentine.com.br',
  instagram: 'https://www.instagram.com/odontodentine/?hl=pt',
  instagramHandle: '@odontodentine',
  address: {
    street: 'R. Saturnino Pessoa, 276 - sala 02 e 03',
    neighborhood: 'Piedade',
    city: 'Jaboatão dos Guararapes',
    state: 'PE',
    zip: '54430-270',
    building: 'Galeria Esquina 23 de Abril',
    full: 'R. Saturnino Pessoa, 276 - sala 02 e 03 - Piedade, Jaboatão dos Guararapes - PE, 54430-270'
  },
  hours: 'Segunda a Sexta: 8h às 18h | Sábado: 8h às 12h',
  mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3949.7897!2d-34.9264!3d-8.1122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMDYnNDQuMCJTIDM0wrA1NSczNS4wIlc!5e0!3m2!1spt-BR!2sbr!4v1234567890'
};

export const treatments = [
  {
    id: 1,
    title: 'Implantes Dentários',
    description: 'Recupere seu sorriso com segurança e naturalidade',
    fullDescription: 'Os implantes dentários são a solução mais moderna e eficaz para substituir dentes perdidos. Utilizamos tecnologia de ponta para garantir resultados naturais e duradouros.',
    indication: 'Indicado para pessoas que perderam um ou mais dentes e desejam recuperar a função mastigatória e estética do sorriso.',
    benefits: ['Aparência natural', 'Durabilidade', 'Preservação óssea', 'Conforto ao mastigar'],
    duration: '3 a 6 meses (incluindo período de osseointegração)'
  },
  {
    id: 2,
    title: 'Harmonização Orofacial',
    description: 'Realce a beleza natural do seu rosto',
    fullDescription: 'Procedimentos estéticos minimamente invasivos que valorizam os traços faciais, proporcionando rejuvenescimento e equilíbrio.',
    indication: 'Para quem busca suavizar rugas, aumentar volume labial, definir contorno facial e melhorar a aparência geral.',
    benefits: ['Rejuvenescimento facial', 'Resultados naturais', 'Procedimento rápido', 'Mínimo desconforto'],
    duration: '30 a 60 minutos por sessão'
  },
  {
    id: 3,
    title: 'Ortodontia',
    description: 'Aparelhos e alinhadores para um sorriso perfeito',
    fullDescription: 'Correção de posicionamento dentário com aparelhos fixos ou alinhadores transparentes, proporcionando saúde e estética.',
    indication: 'Para correção de dentes tortos, mordida cruzada, apinhamento dentário e outros problemas de alinhamento.',
    benefits: ['Melhora da mastigação', 'Estética aprimorada', 'Facilita higiene', 'Previne desgastes'],
    duration: '12 a 36 meses, dependendo da complexidade'
  },
  {
    id: 4,
    title: 'Clareamento Dental',
    description: 'Dentes mais brancos e um sorriso radiante',
    fullDescription: 'Tratamento seguro e eficaz para clarear os dentes, removendo manchas e devolvendo o brilho natural.',
    indication: 'Para quem deseja clarear os dentes amarelados ou manchados por café, vinho, cigarro ou envelhecimento natural.',
    benefits: ['Resultados rápidos', 'Procedimento seguro', 'Autoestima elevada', 'Sorriso mais jovem'],
    duration: '1 a 3 sessões de 40 minutos'
  },
  {
    id: 5,
    title: 'Prótese Dentária',
    description: 'Restaure a função e estética dos seus dentes',
    fullDescription: 'Próteses fixas e removíveis personalizadas que devolvem a função mastigatória e a beleza do sorriso.',
    indication: 'Para substituição de dentes perdidos ou muito danificados, restaurando função e estética.',
    benefits: ['Recuperação da mastigação', 'Aparência natural', 'Conforto', 'Melhora na fala'],
    duration: 'Varia de 2 a 6 semanas'
  },
  {
    id: 6,
    title: 'Endodontia (Canal)',
    description: 'Salve seu dente com tratamento especializado',
    fullDescription: 'Tratamento de canal moderno e confortável para salvar dentes comprometidos por cáries profundas ou infecções.',
    indication: 'Quando há infecção ou inflamação na polpa do dente, causando dor intensa ou sensibilidade.',
    benefits: ['Elimina a dor', 'Preserva o dente', 'Procedimento indolor', 'Evita extrações'],
    duration: '1 a 3 sessões de 60 minutos'
  },
  {
    id: 7,
    title: 'Odontopediatria',
    description: 'Cuidado especializado para o sorriso dos pequenos',
    fullDescription: 'Atendimento odontológico infantil com técnicas lúdicas que tornam a experiência agradável e educativa.',
    indication: 'Para crianças desde o nascimento até a adolescência, prevenindo e tratando problemas bucais.',
    benefits: ['Prevenção precoce', 'Experiência positiva', 'Educação em saúde bucal', 'Acompanhamento do crescimento'],
    duration: 'Consultas de 30 a 60 minutos'
  },
  {
    id: 8,
    title: 'Periodontia',
    description: 'Saúde das gengivas e estruturas de suporte',
    fullDescription: 'Tratamento especializado das gengivas e estruturas que sustentam os dentes, prevenindo e tratando doenças periodontais.',
    indication: 'Para tratamento de gengivite, periodontite, sangramento gengival e limpeza profunda.',
    benefits: ['Previne perda dentária', 'Elimina mau hálito', 'Reduz inflamação', 'Melhora saúde geral'],
    duration: '1 a 4 sessões, conforme necessidade'
  }
];

export const differentials = [
  {
    id: 1,
    title: 'Profissionais Especializados',
    description: 'Equipe altamente qualificada e em constante atualização'
  },
  {
    id: 2,
    title: 'Equipamentos de Última Geração',
    description: 'Tecnologia avançada para diagnósticos precisos e tratamentos eficazes'
  },
  {
    id: 3,
    title: 'Atendimento Humanizado',
    description: 'Cuidado personalizado com foco no conforto e bem-estar do paciente'
  },
  {
    id: 4,
    title: 'Estrutura Moderna',
    description: 'Ambiente confortável e acolhedor com equipamentos de ponta'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Maria Silva',
    text: 'Excelente atendimento! Fiz meu implante na OdontoDentine e o resultado ficou perfeito. Equipe muito atenciosa e profissional.',
    rating: 5
  },
  {
    id: 2,
    name: 'João Santos',
    text: 'Recuperei minha autoestima com o clareamento dental. Ambiente muito agradável e dentistas muito competentes.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana Paula',
    text: 'Meu filho adora vir ao dentista! A equipe de odontopediatria é maravilhosa e muito paciente com as crianças.',
    rating: 5
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Dra. Juliana Dentine',
    specialty: 'Implantodontia e Prótese',
    cro: 'CRO-PE 12345',
    description: 'Especialista em reabilitação oral com mais de 10 anos de experiência'
  },
  {
    id: 2,
    name: 'Dr. Carlos Oliveira',
    specialty: 'Ortodontia',
    cro: 'CRO-PE 23456',
    description: 'Mestre em Ortodontia com foco em alinhadores transparentes'
  },
  {
    id: 3,
    name: 'Dra. Beatriz Costa',
    specialty: 'Harmonização Orofacial',
    cro: 'CRO-PE 34567',
    description: 'Especialista em estética facial e procedimentos minimamente invasivos'
  },
  {
    id: 4,
    name: 'Dr. Roberto Lima',
    specialty: 'Endodontia',
    cro: 'CRO-PE 45678',
    description: 'Especialista em tratamento de canal com técnicas modernas'
  }
];

export const about = {
  mission: 'Oferecer tratamentos odontológicos de excelência, com tecnologia de ponta e atendimento humanizado, transformando sorrisos e vidas.',
  vision: 'Ser referência em odontologia na região, reconhecida pela qualidade dos serviços, inovação e satisfação dos pacientes.',
  values: ['Ética profissional', 'Excelência técnica', 'Atendimento humanizado', 'Inovação constante', 'Compromisso com resultados']
};